import { render, staticRenderFns } from "./TableSubjects.vue?vue&type=template&id=2811bde3&"
import script from "./TableSubjects.vue?vue&type=script&lang=js&"
export * from "./TableSubjects.vue?vue&type=script&lang=js&"
import style0 from "./TableSubjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2811bde3')) {
      api.createRecord('2811bde3', component.options)
    } else {
      api.reload('2811bde3', component.options)
    }
    module.hot.accept("./TableSubjects.vue?vue&type=template&id=2811bde3&", function () {
      api.rerender('2811bde3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/components/TableSubjects.vue"
export default component.exports